var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFancyCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.47311 2.12939H4.52645C3.08561 2.12939 1.91895 3.30189 1.91895 4.73689V10.2261C1.91895 11.6611 3.09145 12.8336 4.52645 12.8336H9.46728C10.9081 12.8336 12.0748 11.6611 12.0748 10.2261V4.73689C12.0806 3.29606 10.9081 2.12939 9.47311 2.12939Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37151 1.1665H5.62984C5.02318 1.1665 4.52734 1.6565 4.52734 2.26317V2.8115C4.52734 3.41817 5.01734 3.90817 5.62401 3.90817H8.37151C8.97818 3.90817 9.46818 3.41817 9.46818 2.8115V2.26317C9.47401 1.6565 8.97818 1.1665 8.37151 1.1665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFancyCopy);
export default __webpack_public_path__ + "static/media/fancy-copy.4b5fd37862163476570246850b6ef36d.svg";
export { ForwardRef as ReactComponent };